import { render, staticRenderFns } from "./DMVTabs.vue?vue&type=template&id=43a5abb0&scoped=true&"
import script from "./DMVTabs.vue?vue&type=script&lang=js&"
export * from "./DMVTabs.vue?vue&type=script&lang=js&"
import style0 from "./DMVTabs.vue?vue&type=style&index=0&id=43a5abb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a5abb0",
  null
  
)

export default component.exports